import { Box, SvgIcon, Typography } from '@material-ui/core';
import React, { memo } from 'react';
import { OrgUserStatus as OrgUserStatusType } from 'src/types';
import StatusIcon from './StatusIcon';
import { useStylesOrgUserStatus } from './styles';

type Props = {
  status: OrgUserStatusType;
};

const OrgUserStatus: React.FC<Props> = ({ status }) => {
  const classes = useStylesOrgUserStatus({ status });

  return (
    <Box display="flex" alignItems="center">
      <SvgIcon
        name={`status-icon-${status}`}
        className={classes.icon}
        data-testid="status-icon"
      >
        <StatusIcon status={status} />
      </SvgIcon>
      <Typography
        variant="subtitle2"
        className={classes.title}
        data-testid="status-title"
      >
        {status.toLocaleLowerCase()}
      </Typography>
    </Box>
  );
};

export default memo(OrgUserStatus);
